import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import getFindPeopleResultsAsEntityIds from './getFindPeopleResultsAsEntityIds';
const PRIVATE_DL_ROUTING_TYPE = 'PDL';

export default function getDisplayName(persona: FindRecipientPersonaType): string {
    let email = persona.EmailAddress;
    let isPDL = email.RoutingType === PRIVATE_DL_ROUTING_TYPE;

    return isPDL ? email.Name : getFindPeopleResultsAsEntityIds([persona])[0];
}
